import { Loading } from '@/components/loading/Loading';

import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';

export const NotAuthenticated: FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/auth/signin', { state: { from: location.pathname } });
  }, [navigate]);

  return <Loading className="h-screen" />;
};
